import { Button, Col, Row, Container, Table } from 'react-bootstrap';
import toast, { Toaster } from "react-hot-toast";
import { useState, useEffect } from 'react';
import '../css/common.css';
import '../css/hover.css'
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { saveForm, deleteForm } from '../store/Slices/formSlice';
import useValidation from '../helpers/validation';
import * as XLSX from 'xlsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload, faTrash, faDownload } from '@fortawesome/free-solid-svg-icons';

function Spain() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userEmail = sessionStorage.getItem('email');

    useEffect(() => {
        const fetchData = async () => {
            if (!userEmail) {
                navigate('/');
                return;
            }
            const form = JSON.parse(localStorage.getItem('form'));

            if (form?.country?.country === 'Spain') {
                fillForm(form);
            }
        };

        fetchData();
    }, [dispatch, navigate]);

    const { validateInput, validationStates, setValidationStates } = useValidation();

    const [name, setName] = useState();
    const [reseller, setReseller] = useState();
    const [address, setAddress] = useState();
    const [city, setCity] = useState();
    const [zip, setZip] = useState();
    const [custName, setCustName] = useState();
    const [vat, setVat] = useState();
    const [custAddress, setCustAddress] = useState();
    const [custCity, setCustCity] = useState();
    const [custZip, setCustZip] = useState();
    const [accNum, setAccNum] = useState();
    const [mbn, setMbn] = useState();
    const [date, setDate] = useState();
    const handleDateChange = (e) => {
        const selectedDate = new Date(e.target.value);
        const today = new Date();
        const oneWeekFromToday = new Date(today.setDate(today.getDate() + 7));

        oneWeekFromToday.setHours(0, 0, 0, 0);
        selectedDate.setHours(0, 0, 0, 0);

        const isWeekend = selectedDate.getDay() === 0 || selectedDate.getDay() === 6;

        if (selectedDate < oneWeekFromToday) {
            toast.error("Please select a date at least one week from today.");
            return;
        }

        if (isWeekend) {
            toast.error("Weekends are not allowed for porting.");
            return;
        }

        setDate(e.target.value);
    };

    const [startTime, setStartTime] = useState('');
    //const [endTime, setEndTime] = useState('');
    // const handleStartTimeChange = (e) => {
    //     const time = e.target.value;
    //     setStartTime(time);
    //     if (!isValidTimeWindow(time, endTime)) {
    //         setValidationStates(prev => ({
    //             ...prev,
    //             startTime: false,
    //             endTime: false,
    //         }));
    //     } else {
    //         setValidationStates(prev => ({
    //             ...prev,
    //             startTime: true,
    //             endTime: true,
    //         }));
    //     }
    // };


    // const handleEndTimeChange = (e) => {
    //     const time = e.target.value;
    //     setEndTime(time);

    //     if (!isValidTimeWindow(startTime, time)) {
    //         setValidationStates(prev => ({
    //             ...prev,
    //             startTime: false,
    //             endTime: false,
    //         }));
    //     } else {
    //         setValidationStates(prev => ({
    //             ...prev,
    //             startTime: true,
    //             endTime: true,
    //         }));
    //     }
    // };

    const handleStartTimeChange = (e) => {
        const time = e.target.value;
        const [hours, minutes] = time.split(':').map(Number);

        if (hours < 8 || hours > 20 || (hours === 20 && minutes > 0)) {
            toast.error('Start time must be between 08:00 AM and 08:00 PM');
            setStartTime('');
            setValidationStates(prev => ({ ...prev, startTime: false }));
            return;
        }

        setStartTime(time);

        // if (endTime && !isValidTimeWindow(time, endTime)) {
        //     toast.error('Time window must be within 3 hours and end time must be after start time.');
        //     setValidationStates(prev => ({ ...prev, startTime: false, endTime: false }));
        // } else {
        //     setValidationStates(prev => ({ ...prev, startTime: true, endTime: true }));
        // }
    };



    // const handleEndTimeChange = (e) => {
    //     const time = e.target.value;
    //     const [hours, minutes] = time.split(':').map(Number);

    //     if (hours < 8 || hours > 20 || (hours === 20 && minutes > 0)) {
    //         toast.error('End time must be between 08:00 AM and 08:00 PM');
    //         setEndTime('');
    //         setValidationStates(prev => ({ ...prev, endTime: false }));
    //         return;
    //     }

    //     setEndTime(time);

    //     if (startTime && !isValidTimeWindow(startTime, time)) {
    //         toast.error('Time window must be within 3 hours and end time must be after start time.');
    //         setValidationStates(prev => ({ ...prev, startTime: false, endTime: false }));
    //     } else {
    //         setValidationStates(prev => ({ ...prev, startTime: true, endTime: true }));
    //     }
    // };


    // const isValidTimeWindow = (start, end) => {
    //     if (!start || !end) return false;
    //     const [sh, sm] = start.split(':').map(Number);
    //     const [eh, em] = end.split(':').map(Number);
    //     const diff = (eh * 60 + em) - (sh * 60 + sm);
    //     return diff > 0 && diff <= 180; // Must be > 0 and ≤ 180 minutes
    // };

    // const isValidTimeWindow = (start, end) => {
    //     if (!start || !end) return false;

    //     const [sh, sm] = start.split(':').map(Number);
    //     const [eh, em] = end.split(':').map(Number);
    //     const startMins = sh * 60 + sm;
    //     const endMins = eh * 60 + em;

    //     const diff = endMins - startMins;
    //     return diff > 0 && diff <= 180; // max 3 hours
    // };


    const [contactNum, setContactNum] = useState();
    const [position, setPosition] = useState();
    const [printName, setPrintName] = useState();
    const [dateSign, setDateSign] = useState();

    const [checkBox1, setCheckBox1] = useState(false);
    const [checkBox2, setCheckBox2] = useState(false);
    const [checkBox3, setCheckBox3] = useState(false);

    //-----------------------------------------------FillForm-------------------------------------------------//

    const fillForm = (form) => {
        document.querySelector('#name').value = form?.country?.donor?.name ?? '';
        document.querySelector('#reseller').value = form?.country?.donor?.reseller ?? '';
        document.querySelector('#address').value = form?.country?.donor?.address ?? '';
        document.querySelector('#city').value = form?.country?.donor?.city ?? '';
        document.querySelector('#zip').value = form?.country?.donor?.zip ?? '';
        setName(form?.country?.donor?.name ?? '');
        setReseller(form?.country?.donor?.reseller ?? '');
        setAddress(form?.country?.donor?.address ?? '');
        setCity(form?.country?.donor?.city ?? '');
        setZip(form?.country?.donor?.zip ?? '');

        document.querySelector('#custName').value = form?.country?.customer?.custName ?? '';
        document.querySelector('#vat').value = form?.country?.customer?.vat ?? '';
        document.querySelector('#custAddress').value = form?.country?.customer?.custAddress ?? '';
        document.querySelector('#custCity').value = form?.country?.customer?.custCity ?? '';
        document.querySelector('#custZip').value = form?.country?.customer?.custZip ?? '';
        document.querySelector('#accNum').value = form?.country?.customer?.accNum ?? '';

        setCustName(form?.country?.customer?.custName ?? '');
        setVat(form?.country?.customer?.vat ?? '');
        setCustAddress(form?.country?.customer?.custAddress ?? '');
        setCustCity(form?.country?.customer?.custCity ?? '');
        setCustZip(form?.country?.customer?.custZip ?? '');
        setAccNum(form?.country?.customer?.accNum ?? '');

        setTableDataSingle(form?.country?.Single_Number ?? []);
        setTableDataRange(form?.country?.Number_Range ?? []);

        document.querySelector('#mbn').value = form?.country?.mbn ?? '';
        setMbn(form?.country?.mbn ?? '');

        document.querySelector('#date').value = form?.country?.date ?? '';
        setDate(form?.country?.date ?? '');
        document.querySelector('#startTime').value = form?.country?.startTime ?? '';
        setStartTime(form?.country?.startTime ?? '');
        // document.querySelector('#endTime').value = form?.country?.endTime ?? '';
        // setEndTime(form?.country?.endTime ?? '');

        document.querySelector('#printName').value = form?.country?.requestor?.printName ?? '';
        document.querySelector('#contactNum').value = form?.country?.requestor?.contactNum ?? '';
        document.querySelector('#position').value = form?.country?.requestor?.position ?? '';
        document.querySelector('#dateSign').value = form?.country?.requestor?.dateSign ?? '';
        document.querySelector('#checkBox1').value = form?.country?.requestor?.checkBox1 ?? false;
        document.querySelector('#checkBox2').value = form?.country?.requestor?.checkBox2 ?? false;
        document.querySelector('#checkBox3').value = form?.country?.requestor?.checkBox3 ?? false;
        setPrintName(form?.country?.requestor?.printName ?? '');
        setContactNum(form?.country?.requestor?.contactNum ?? '');
        setPosition(form?.country?.requestor?.position ?? '');
        setDateSign(form?.country?.requestor?.dateSign ?? '');
        setCheckBox1(form?.country?.requestor?.checkBox1 ?? '');
        setCheckBox2(form?.country?.requestor?.checkBox2 ?? '');
        setCheckBox3(form?.country?.requestor?.checkBox3 ?? '');

    }

    //-----------------------------------------------Hover-------------------------------------------------//

    const [hoveredField, setHoveredField] = useState(null); //hovered field

    const handleMouseEnter = (field) => {
        setHoveredField(field);
    };

    const handleMouseLeave = () => {
        setHoveredField(null);
    };

    //--------------------------------table declaration (Single)--------------------------------------//

    const [tableDataSingle, setTableDataSingle] = useState([{ id: Date.now(), num: '' }]);

    //adding a row
    const addRow_single = () => {
        setTableDataSingle([...tableDataSingle, { id: Date.now(), num: '' }]);
    };

    //removing a row
    const removeRow_single = (id) => {
        setTableDataSingle(tableDataSingle.filter(row => row.id !== id));
    };

    //change handler of table
    const handleChange_tableSingle = (id, key, value) => {
        const updatedData = tableDataSingle.map(row => {
            if (row.id === id) {
                return { ...row, [key]: value };
            }
            return row;
        });
        setTableDataSingle(updatedData);
    };

    //--------------------------------table declaration (Number Range)--------------------------------------//

    const [tableDataRange, setTableDataRange] = useState([{ id: Date.now(), sNumber: '', eNumber: '' }]);

    //adding a row
    const addRow_range = () => {
        setTableDataRange([...tableDataRange, { id: Date.now(), sNumber: '', eNumber: '' }]);
    };

    //removing a row
    const removeRow_range = (id) => {
        setTableDataRange(tableDataRange.filter(row => row.id !== id));
    };

    //change handler of table
    const handleChange_tableRange = (id, key, value) => {
        const updatedData = tableDataRange.map(row => {
            if (row.id === id) {
                return { ...row, [key]: value };
            }
            return row;
        });
        setTableDataRange(updatedData);
    };

    const fileInputRef = React.createRef();  // Create a reference to the file input element
    const [uploadedFileName, setUploadedFileName] = useState('');

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        // Display the file name
        setUploadedFileName(file.name);

        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];

            // Read headers from row 5
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1, range: 4 });
            if (!jsonData.length) {
                toast.error('Uploaded file is empty or has an invalid format.');
                setUploadedFileName('');
                return;
            }

            const fileHeaders = jsonData[0] || [];
            const expectedHeaders = ['Public from', 'Public to', 'Private from', 'Private to', 'Local Country Value'];

            // Check if headers match
            if (!expectedHeaders.every((header, index) => header === fileHeaders[index])) {
                toast.error('Uploaded file does not match the expected format.');
                setUploadedFileName('');
                return;
            }

            // Read actual data from row 6 onwards
            const dataRows = jsonData.slice(1);

            // Extract relevant data for tableDataRange (first two columns: start & end number)
            const formattedDataRange = dataRows.map((row, index) => ({
                id: index + 1,
                sNumber: row[0] ? row[0].toString() : '', // First column (start number)
                eNumber: row[1] ? row[1].toString() : '', // Second column (end number)
            }));

            // Set the table data for number range
            setTableDataRange(formattedDataRange);

            // Trigger validation for each row after setting data (similar to previous logic)
            formattedDataRange.forEach(row => {
                const startValue = row.sNumber;
                const endValue = row.eNumber;

                // Validate rangeStart (9 digits)
                if (startValue !== '' && !/^\d{9}$/.test(startValue)) {
                    setValidationStates(prev => ({
                        ...prev,
                        [`startNumber-${row.id}`]: false,
                    }));
                } else {
                    setValidationStates(prev => ({
                        ...prev,
                        [`startNumber-${row.id}`]: true,
                    }));
                }

                // Validate rangeStop (9 digits)
                if (endValue !== '' && !/^\d{9}$/.test(endValue)) {
                    setValidationStates(prev => ({
                        ...prev,
                        [`endNumber-${row.id}`]: false,
                    }));
                } else {
                    setValidationStates(prev => ({
                        ...prev,
                        [`endNumber-${row.id}`]: true,
                    }));
                }

                // Check if end range is greater than or equal to start range
                // if (startValue && endValue && parseInt(endValue, 10) < parseInt(startValue, 10)) {
                //     setValidationStates(prev => ({
                //         ...prev,
                //         [`startNumber-${row.id}`]: false,
                //         [`endNumber-${row.id}`]: false,
                //     }));
                // }

            });
        };
        reader.readAsArrayBuffer(file);
    };

    const removeUploadedFile = () => {
        // Clear the uploaded file name state
        setUploadedFileName('');

        // Reset the file input field value to clear the selected file
        fileInputRef.current.value = '';

        // Clear the table data by setting it to an empty array
        setTableDataRange([]);

        // Optionally clear the table data for 'Number Range' table
        setTableDataRange([]);
    };

    const handleDownload = async () => {
        try {
            // Fetch the file (portabilityImportTemplate.xlsx) from the server
            const response = await fetch(`/portabilityImportTemplate.xlsx?t=${new Date().getTime()}`);

            // Check if the response is valid
            if (!response.ok) throw new Error("Network response was not ok");

            // Convert the response to a Blob
            const blob = await response.blob();

            // Create a URL for the Blob to allow it to be downloaded
            const url = window.URL.createObjectURL(blob);

            // Create an anchor tag dynamically and trigger a click to download the file
            const a = document.createElement("a");
            a.href = url;
            a.download = "portabilityImportTemplate.xlsx"; // File name for download
            document.body.appendChild(a);
            a.click(); // Initiate the download
            document.body.removeChild(a); // Clean up by removing the anchor element
        } catch (error) {
            // Catch any error that occurs during the download process
            console.error("Download failed:", error);
        }
    };

    //-------------------------------------------creating Schema----------------------------------------//

    const json = {
        "country": {
            "country": "Spain",
            "donor": {
                "name": name,
                "reseller": reseller,
                "address": address,
                "city": city,
                "zip": zip
            },
            "customer": {
                "custName": custName,
                "vat": vat,
                "custAddress": custAddress,
                "custCity": custCity,
                "custZip": custZip,
                "accNum": accNum
            },
            "Single_Number": tableDataSingle,
            "Number_Range": tableDataRange,
            "mbn": mbn,
            "date": date,
            "startTime": startTime,
            // "endTime": endTime,

            "requestor": {
                "printName": printName,
                "contactNum": contactNum,
                "position": position,
                "dateSign": dateSign,
                "checkBox1": checkBox1,
                "checkBox2": checkBox2,
                "checkBox3": checkBox3,
            }
        },
        "email": sessionStorage.getItem('email'),
    };

    const jsonString = JSON.stringify(json);

    //console.log(jsonString);

    //-----------------------------------------sending request---------------------------------------------//

    // async function Submit(e) {
    //     e.preventDefault();

    //     let validationErrors = {};

    //     // Required field checks
    //     if (!name) validationErrors.name = 'Please fill in Operator Name';

    //     if (!custName) validationErrors.custName = 'Please fill in Customer Name';

    //     if (!vat) validationErrors.vat = 'Please fill in VAT';

    //     if (!custAddress) validationErrors.custAddress = 'Please fill in Customer Address';

    //     if (!custCity) validationErrors.custCity = 'Please fill in City Name';

    //     if (!custZip) validationErrors.custZip = 'Please fill in Zip';

    //     if (!date) validationErrors.date = 'Please fill in Date';

    //     if (!startTime) validationErrors.startTime = 'Please fill in Start time';

    //     if (!endTime) validationErrors.endTime = 'Please fill in End time';

    //     if (!isValidTimeWindow(startTime, endTime)) {
    //         setValidationStates(prev => ({
    //             ...prev,
    //             startTime: false,
    //             endTime: false,
    //         }));

    //         toast.error('Porting window must be within 3 hours and end time must be after start time.');
    //         const elem = document.getElementById('startTime');
    //         if (elem) elem.scrollIntoView({ behavior: "smooth", block: "center" });
    //         return;
    //     }

    //     if (!mbn) validationErrors.mbn = 'Please fill in MBN';

    //     if (!printName) validationErrors.printName = 'Please fill in Print Name';

    //     if (!contactNum) validationErrors.contactNum = 'Please fill in Contact Number';

    //     if (!dateSign) validationErrors.dateSign = 'Please fill in Date of signature';

    //     if (!checkBox1) validationErrors.checkBox1 = 'Please check the field';

    //     if (!checkBox2) validationErrors.checkBox2 = 'Please check the field';

    //     if (!checkBox3) validationErrors.checkBox3 = 'Please check the field';

    //     const hasValidationError = Object.keys(validationErrors).length > 0;

    //     if (hasValidationError) {
    //         setValidationStates(prevState => ({
    //             ...prevState,
    //             ...Object.keys(validationErrors).reduce((acc, key) => {
    //                 acc[key] = false;
    //                 return acc;
    //             }, {})
    //         }));

    //         const firstErrorKey = Object.keys(validationErrors)[0];
    //         const firstErrorMessage = validationErrors[firstErrorKey];
    //         const elem = document.getElementById(firstErrorKey);
    //         if (elem) elem.scrollIntoView({ behavior: "smooth", block: "center" });

    //         toast.error(firstErrorMessage);
    //         return;
    //     }

    //     // Validation state check for red-highlighted fields
    //     const falseKeys = Object.entries(validationStates)
    //         .filter(([key, value]) => value === false)
    //         .map(([key]) => key);

    //     if (falseKeys.length > 0) {
    //         const readableErrors = falseKeys.map(key => {
    //             if (key.includes('startNumber')) return 'Start Number';
    //             if (key.includes('endNumber')) return 'End Number';
    //             return key;
    //         });

    //         toast.error(`Please make sure fields in red are correct:\n${readableErrors.join(', ')}`);

    //         const elem = document.getElementById(falseKeys[0]);
    //         if (elem) elem.scrollIntoView({ behavior: "smooth", block: "center" });
    //         return;
    //     }

    //     // Proceed with form submission
    //     try {
    //         const response = await fetch(`${process.env.REACT_APP_API_URL}/generate_loa`, {
    //             method: 'POST',
    //             headers: {
    //                 "Content-Type": "application/json",
    //             },
    //             body: jsonString
    //         });

    //         if (!response.ok) {
    //             throw new Error('Network response was not ok');
    //         }

    //         const blobData = await response.blob();
    //         const url = URL.createObjectURL(blobData);
    //         const a = document.createElement('a');
    //         a.href = url;
    //         a.download = address + '-LOA.docx';
    //         document.body.appendChild(a);
    //         a.click();
    //         document.body.removeChild(a);
    //         URL.revokeObjectURL(url);

    //     } catch (error) {
    //         console.error('Error downloading file: ', error);
    //         window.location.href = 'https://my-service-space.orange-business.com/wacsmss/group/mssportal/home';
    //     }
    // }

    async function Submit(e) {
        e.preventDefault();

        let validationErrors = {};

        // Required field checks
        if (!name) validationErrors.name = 'Please fill in Operator Name';
        if (!custName) validationErrors.custName = 'Please fill in Customer Name';
        if (!vat) validationErrors.vat = 'Please fill in VAT';
        if (!custAddress) validationErrors.custAddress = 'Please fill in Customer Address';
        if (!custCity) validationErrors.custCity = 'Please fill in City Name';
        if (!custZip) validationErrors.custZip = 'Please fill in Zip';
        if (!date) validationErrors.date = 'Please fill in Date';
        if (!startTime) validationErrors.startTime = 'Please fill in Start time';
        // if (!endTime) validationErrors.endTime = 'Please fill in End time';
        if (!mbn) validationErrors.mbn = 'Please fill in MBN';
        if (!printName) validationErrors.printName = 'Please fill in Print Name';
        if (!contactNum) validationErrors.contactNum = 'Please fill in Contact Number';
        if (!dateSign) validationErrors.dateSign = 'Please fill in Date of signature';
        if (!checkBox1) validationErrors.checkBox1 = 'Please check the field';
        if (!checkBox2) validationErrors.checkBox2 = 'Please check the field';
        if (!checkBox3) validationErrors.checkBox3 = 'Please check the field';

        // Additional time window validation
        // if (startTime && !isValidTimeWindow(startTime)) {
        //     validationErrors.startTime = 'Porting window must be within 3 hours';
        //     //validationErrors.endTime = 'Porting window must be within 3 hours';
        // }

        // Handle any validation errors
        const hasValidationError = Object.keys(validationErrors).length > 0;

        if (hasValidationError) {
            setValidationStates(prevState => ({
                ...prevState,
                ...Object.keys(validationErrors).reduce((acc, key) => {
                    acc[key] = false;
                    return acc;
                }, {})
            }));

            const firstErrorKey = Object.keys(validationErrors)[0];
            const firstErrorMessage = validationErrors[firstErrorKey];
            const elem = document.getElementById(firstErrorKey);
            if (elem) elem.scrollIntoView({ behavior: "smooth", block: "center" });

            toast.error(firstErrorMessage);
            return;
        }

        // Check validationStates for red-highlighted fields
        const falseKeys = Object.entries(validationStates)
            .filter(([key, value]) => value === false)
            .map(([key]) => key);

        if (falseKeys.length > 0) {
            const readableErrors = falseKeys.map(key => {
                if (key.includes('startNumber')) return 'Start Number';
                if (key.includes('endNumber')) return 'End Number';
                return key;
            });

            toast.error(`Please make sure fields in red are correct:\n${readableErrors.join(', ')}`);

            const elem = document.getElementById(falseKeys[0]);
            if (elem) elem.scrollIntoView({ behavior: "smooth", block: "center" });
            return;
        }

        // Proceed with form submission
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/generate_loa`, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                },
                body: jsonString
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const blobData = await response.blob();
            const url = URL.createObjectURL(blobData);
            const a = document.createElement('a');
            a.href = url;
            a.download = address + '-LOA.docx';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Error downloading file: ', error);
            window.location.href = 'https://my-service-space.orange-business.com/wacsmss/group/mssportal/home';
        }
    }


    //----------------------------------------------RESET--------------------------------------------------//

    async function Reset(e) {
        const dataToBeDeleted = { "email": userEmail };
        dispatch(deleteForm(dataToBeDeleted));
        localStorage.removeItem('form');
        window.location.reload();
    }

    async function save(e) {
        e.preventDefault();
        const falseKeys = Object.entries(validationStates)
            .filter(([key, value]) => {
                const element = document.getElementById(key);
                return value === false && element && element.value.trim() !== '';
            })
            .map(([key, value]) => key);

        if (falseKeys.length > 0) {
            const elem = document.getElementById(falseKeys[0]);
            elem.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            toast.error(`Please make sure following fields in red are correct before saving `);
            return;
        }

        localStorage.setItem('form', JSON.stringify(json));
        const dataToBeSaved = { "email": userEmail, "json_data": json };
        try {
            const response = await dispatch(saveForm(dataToBeSaved));
            if (response?.payload?.message === "success") {
                toast.success('Form saved successfully');
            }
        } catch (error) {
            toast.error('There was an error processing your request.');
        }
    }

    //-----------------------------------------------JSX----------------------------------------------------//

    return (
        <div>

            <Toaster position="top-center" reverseOrder={false}></Toaster>

            <div className='french'>

                <Container>

                    <p><strong>Mandatory fields are marked by *</strong></p> <br></br>

                    <h2 className='heading'>Donor / Loosing Operator</h2> <br></br>

                    <Row>

                        <Col
                            onMouseEnter={() => handleMouseEnter('name')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Operator Name*</label> <br />
                            <input
                                onChange={(e) => setName(e.target.value)}
                                type="text"
                                id="name"
                                placeholder=""
                                className={`inputbox ${validationStates.name === false ? 'error' : ''}`}
                                onBlur={() => validateInput('name', /^[\w\W,]+$/)}

                            />
                            {hoveredField === 'name' && (
                                <div className="hover-description">
                                    Enter local provider should be located in Spain.
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('reseller')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Reseller (in case outside spain)</label> <br />
                            <input
                                onChange={(e) => setReseller(e.target.value)}
                                type="text"
                                id="reseller"
                                placeholder=""
                                className={`inputbox`}
                            />
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('address')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Address</label> <br />
                            <input
                                onChange={(e) => setAddress(e.target.value)}
                                type="text"
                                id="address"
                                placeholder=""
                                className={`inputbox`}
                            />
                        </Col>

                    </Row>

                    <br />

                    <Row>

                        <Col
                            onMouseEnter={() => handleMouseEnter('city')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>City</label> <br />
                            <input
                                onChange={(e) => setCity(e.target.value)}
                                type="text"
                                id="city"
                                placeholder=""
                                className={`inputbox`}
                            />
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('zip')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Zip</label> <br />
                            <input
                                onChange={(e) => setZip(e.target.value)}
                                type="text"
                                id="zip"
                                placeholder=""
                                className={`inputbox`}
                            />
                        </Col>

                    </Row>

                </Container>

                <br></br><br></br>

                <Container>

                    <h2 className='heading'>Customer Details</h2> <br></br>

                    <Row>

                        <Col
                            onMouseEnter={() => handleMouseEnter('custName')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Customer Name*</label> <br />
                            <input
                                onChange={(e) => setCustName(e.target.value)}
                                type="text"
                                id="custName"
                                placeholder=""
                                className={`inputbox ${validationStates.custName === false ? 'error' : ''}`}
                                onBlur={() => validateInput('custName', /^[\w\W,]+$/)}

                            />
                            {hoveredField === 'custName' && (
                                <div className="hover-description">
                                    Just the current customer name.
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('vat')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>VAT*</label> <br />
                            <input
                                onChange={(e) => setVat(e.target.value)}
                                type="text"
                                id="vat"
                                placeholder=""
                                className={`inputbox ${validationStates.vat === false ? 'error' : ''}`}
                                onBlur={() => validateInput('vat', /^[a-zA-Z0-9]{10}$/)}

                            />
                            {hoveredField === 'vat' && (
                                <div className="hover-description">
                                    Should be the VAT belongs to entity in Spain.
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('custAddress')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Address*</label> <br />
                            <input
                                onChange={(e) => setCustAddress(e.target.value)}
                                type="text"
                                id="custAddress"
                                placeholder=""
                                className={`inputbox ${validationStates.custAddress === false ? 'error' : ''}`}
                                onBlur={() => validateInput('custAddress', /^[\w\W,]+$/)}

                            />
                            {hoveredField === 'custAddress' && (
                                <div className="hover-description">
                                    Current address, all numbers to be in the same exact Spanish address per LOA.
                                </div>
                            )}
                        </Col>

                    </Row>

                    <br></br>

                    <Row>

                        <Col
                            onMouseEnter={() => handleMouseEnter('custCity')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>City*</label> <br />
                            <input
                                onChange={(e) => setCustCity(e.target.value)}
                                type="text"
                                id="custCity"
                                placeholder=""
                                className={`inputbox ${validationStates.custCity === false ? 'error' : ''}`}
                                onBlur={() => validateInput('custCity', /^[\w\W,]+$/)}

                            />
                            {hoveredField === 'custCity' && (
                                <div className="hover-description">
                                    Current address.
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('custZip')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Zip*</label> <br />
                            <input
                                onChange={(e) => setCustZip(e.target.value)}
                                type="text"
                                id="custZip"
                                placeholder=""
                                className={`inputbox ${validationStates.custZip === false ? 'error' : ''}`}
                                onBlur={() => validateInput('custZip', /^[\w\W,]+$/)}
                            />
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('accNum')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Customer Account Number at Donor</label> <br />
                            <input
                                onChange={(e) => setAccNum(e.target.value)}
                                type="text"
                                id="accNum"
                                placeholder=""
                                className={`inputbox`}
                            />
                            {hoveredField === 'accNum' && (
                                <div className="hover-description">
                                    As shown on most recent telecommunications bill from donor.
                                </div>
                            )}
                        </Col>

                    </Row>

                </Container>

                <br></br>

                <Container>
                    <h2 className='heading'>Telephone Number/s</h2> <br></br>
                    <p className='heading'>Maximum number of submitted ranges per Porting-in request is 70 ranges or single numbers and all numbers must be in the same exact address</p>

                    <h4 className='text-decoration-underline'>Single Telephone Number(s)</h4> <br></br>

                    <Table striped bordered hover variant="light">
                        <thead>
                            <tr>
                                <th>Number</th>
                            </tr>
                        </thead>
                        <tbody>

                            {tableDataSingle.map(row => (
                                <tr key={row.id}>

                                    <td
                                        onMouseEnter={() => handleMouseEnter(`number-${row.id}`)}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <input
                                            type="text"
                                            id={`number-${row.id}`}
                                            value={row.num}
                                            onChange={(e) => {
                                                const value = e.target.value;

                                                // Update the state with the input value
                                                handleChange_tableSingle(row.id, 'num', value);

                                                // Immediate validation feedback for 9 digits only when not empty
                                                if (value !== '' && !/^\d{9}$/.test(value)) {
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`number-${row.id}`]: false,
                                                    }));
                                                } else {
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`number-${row.id}`]: true,
                                                    }));
                                                }
                                            }}
                                            className={`inputbox ${validationStates[`number-${row.id}`] === false && row.num !== '' ? 'error' : ''}`}
                                            onBlur={() => {
                                                // Final validation check on blur for 9 digits only when not empty
                                                if (row.num !== '' && !/^\d{9}$/.test(row.num)) {
                                                    toast.error('Number must be 9 digits.');
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`number-${row.id}`]: false,
                                                    }));
                                                }
                                            }}
                                        />
                                        {/* {hoveredField === `number-${row.id}` && (
                                            <div className="hover-description">
                                                Enter the single number if found to be ported (e.g. 014199800)
                                            </div>
                                        )} */}
                                        {validationStates[`number-${row.id}`] === false && row.num !== '' && (
                                            <div className="error-message">
                                                Number must be 9 digits.
                                            </div>
                                        )}
                                    </td>

                                    <td>
                                        {tableDataSingle.length > 1 && (
                                            <button onClick={() => removeRow_single(row.id)}>Remove</button>
                                        )}
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </Table>

                    <button onClick={addRow_single}>Add Row</button>

                    <br></br><br></br>

                    <h4 className='text-decoration-underline'>Number Range</h4> <br></br>

                    <Row>
                        <Col>
                            <button
                                variant="secondary"
                                className="inputbox"
                                style={{ alignItems: 'center' }}
                                onClick={() => fileInputRef.current.click()}
                            >
                                <FontAwesomeIcon icon={faUpload} style={{ marginRight: '8px' }} />
                                Upload File
                            </button>
                            <input
                                id="fileUploadInput"
                                type="file"
                                accept=".xlsx, .xls"
                                onChange={handleFileUpload}
                                ref={fileInputRef}
                                style={{ display: 'none' }}
                            />
                        </Col>

                        <Col>
                            <button className="inputbox" onClick={handleDownload} style={{ alignItems: 'center' }}>
                                <FontAwesomeIcon icon={faDownload} style={{ marginRight: '8px' }} />
                                Download number range template
                            </button>
                        </Col>

                        <Col>
                            {uploadedFileName && (
                                <button onClick={removeUploadedFile} className="inputbox" style={{ alignItems: 'center' }}>
                                    <FontAwesomeIcon icon={faTrash} style={{ marginRight: '8px' }} />
                                    Remove
                                </button>
                            )}
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            {uploadedFileName && (
                                <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                                    <p style={{ marginRight: '10px' }}>Uploaded File: {uploadedFileName}</p>
                                </div>
                            )}
                        </Col>
                    </Row>

                    <br />
                    <p>The template is the same used for the btd portability request.</p>
                    <br />

                    <Table striped bordered hover variant="light">
                        <thead>
                            <tr>
                                <th>Telephone Numbers Range Start</th>
                                <th>Telephone Numbers Range End</th>
                            </tr>
                        </thead>

                        <tbody>

                            {tableDataRange.map(row => (
                                <tr key={row.id}>

                                    <td
                                        onMouseEnter={() => handleMouseEnter(`startNumber-${row.id}`)}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <input
                                            type="text"
                                            id={`startNumber-${row.id}`} // Corrected ID for num input
                                            value={row.sNumber}
                                            onChange={(e) => {
                                                const value = e.target.value;

                                                // Update the state with the input value
                                                handleChange_tableRange(row.id, 'sNumber', value);

                                                // Immediate validation feedback for 9 digits
                                                if (value && !/^\d{9}$/.test(value)) { // Allow between 9 digits
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`startNumber-${row.id}`]: false,
                                                    }));
                                                } else {
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`startNumber-${row.id}`]: true,
                                                    }));
                                                }
                                            }}
                                            className={`inputbox ${validationStates[`startNumber-${row.id}`] === false ? 'error' : ''}`}
                                            onBlur={() => {
                                                // Final validation check on blur for 9 digits
                                                if (row.sNumber && !/^\d{9}$/.test(row.sNumber)) { // Only validate if value is not empty
                                                    toast.error('Number must be 9 digits.');
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`startNumber-${row.id}`]: false,
                                                    }));
                                                }
                                            }}
                                        />
                                        {validationStates[`startNumber-${row.id}`] === false && row.sNumber !== '' && (
                                            <div className="error-message">
                                                Number must be 9 digits.
                                            </div>
                                        )}
                                    </td>

                                    <td
                                        onMouseEnter={() => handleMouseEnter(`endNumber-${row.id}`)}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <input
                                            type="text"
                                            id={`endNumber-${row.id}`} // Corrected ID for num input
                                            value={row.eNumber}
                                            onChange={(e) => {
                                                const value = e.target.value;

                                                // Update the state with the input value
                                                handleChange_tableRange(row.id, 'eNumber', value);

                                                // Immediate validation feedback for 9 digits
                                                if (value && !/^\d{9}$/.test(value)) { // Allow between 9 digits
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`endNumber-${row.id}`]: false,
                                                    }));
                                                } else {
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`endNumber-${row.id}`]: true,
                                                    }));
                                                }
                                            }}
                                            className={`inputbox ${validationStates[`endNumber-${row.id}`] === false ? 'error' : ''}`}
                                            onBlur={() => {
                                                // Final validation check on blur for 9 digits
                                                if (row.eNumber && !/^\d{9}$/.test(row.eNumber)) { // Only validate if value is not empty
                                                    toast.error('Number must be 9 digits.');
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`endNumber-${row.id}`]: false,
                                                    }));
                                                }
                                            }}
                                        />

                                        {validationStates[`endNumber-${row.id}`] === false && row.eNumber !== '' && (
                                            <div className="error-message">
                                                Number must be between 9 digits.
                                            </div>
                                        )}
                                    </td>

                                    <td>
                                        {tableDataRange.length > 1 && (
                                            <button onClick={() => removeRow_range(row.id)}>Remove</button>
                                        )}
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </Table>

                    <button onClick={addRow_range}>Add Row</button>

                    <br></br><br></br>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('mbn')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>MBN*</label> <br />
                            <input
                                onChange={(e) => setMbn(e.target.value)}
                                type="text"
                                id="mbn"
                                placeholder=""
                                className={`inputbox ${validationStates.mbn === false ? 'error' : ''}`}
                                onBlur={() => validateInput('mbn', /^[\w\W,]+$/)}

                            />
                            {hoveredField === 'mbn' && (
                                <div className="hover-description">
                                    Main billing number for number range.
                                </div>
                            )}
                        </Col>

                        {/* <Col
                            onMouseEnter={() => handleMouseEnter('date')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Porting Window*</label> <br />
                            <input
                                onChange={handleDateChange}
                                type="date"
                                id="date"
                                value={date}
                                className={`inputbox ${validationStates.date === false ? 'error' : ''}`}
                                onBlur={() => validateInput('date', /^.*$/)}
                                min={new Date().toISOString().split('T')[0]} // Greys out past dates including today
                            />

                            {hoveredField === 'date' && (
                                <div className="hover-description">
                                    Portability process takes upto 3 hours, and should be within this time frame (Monday to Friday 08:00 AM - 08:00 PM).
                                </div>
                            )}
                        </Col> */}

                    </Row>

                    <br></br>

                    <Row>
                        <Col onMouseEnter={() => handleMouseEnter('date')} onMouseLeave={handleMouseLeave}>
                            <label>Porting Window*</label>

                            {/* Flex Row for Date + Time Fields */}
                            <div style={{ display: 'flex', gap: '20px', marginTop: '10px', alignItems: 'flex-start', flexWrap: 'wrap' }}>

                                {/* Date Field */}
                                <div style={{ display: 'flex', flexDirection: 'column', flex: '1' }}
                                    onMouseEnter={() => handleMouseEnter('date')}
                                    onMouseLeave={handleMouseLeave}>
                                    <label htmlFor="date">Date</label>
                                    <input
                                        type="date"
                                        id="date"
                                        value={date}
                                        onChange={handleDateChange}
                                        onBlur={() => validateInput('date', /^.*$/)}
                                        min={new Date().toISOString().split('T')[0]}
                                        className={`inputbox ${validationStates.date === false ? 'error' : ''}`}
                                    />
                                </div>

                                {/* Start Time Field */}
                                <div style={{ display: 'flex', flexDirection: 'column', flex: '1' }}>
                                    <label htmlFor="startTime">Preferred Start Time</label>
                                    <input
                                        type="time"
                                        id="startTime"
                                        value={startTime}
                                        onChange={handleStartTimeChange}
                                        min="08:00"
                                        max="20:00"
                                        step="900"
                                        onBlur={() => validateInput('startTime', /^.*$/)}
                                        className={`inputbox ${validationStates.startTime === false ? 'error' : ''}`}
                                    />
                                    <small style={{ color: '#888' }}>08:00 AM – 08:00 PM</small>
                                </div>

                                {/* End Time Field */}
                                {/* <div style={{ display: 'flex', flexDirection: 'column', flex: '1' }}>
                                    <label htmlFor="endTime">End Time</label>
                                    <input
                                        type="time"
                                        id="endTime"
                                        value={endTime}
                                        onChange={handleEndTimeChange}
                                        min="08:00"
                                        max="20:00"
                                        step="900"
                                        onBlur={() => validateInput('endTime', /^.*$/)}
                                        className={`inputbox ${validationStates.endTime === false ? 'error' : ''}`}
                                    />
                                    <small style={{ color: '#888' }}>Max 3 hrs after start time</small>
                                </div> */}
                            </div>

                            {/* Hover Description */}
                            {hoveredField === 'date' && (
                                <div className="hover-description" style={{ marginTop: '10px' }}>
                                    Portability must occur Monday–Friday between 08:00 AM and 08:00 PM, and should be completed within 3 hours. The preferred start time is indicative.
                                </div>
                            )}
                        </Col>
                    </Row>

                </Container>

                <br></br>

                <br></br>

                <Container>

                    <p>As the end user subscriber, I designate Orange, to act as my agent in changing the Telecom Operator of each of the telephone number(s) specified on this form
                        I recognise that it is my responsibility to arrange cessation of or changes to any other services provided by the current Communications Provider.* <br></br>
                        <strong>I confirm that I have the authority to make this instruction.</strong>
                    </p>

                    <br></br>

                    <h2 className='heading'>Authorized Contact for Porting details</h2> <br></br>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('printName')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Contact Print Name*</label> <br />
                            <input
                                onChange={(e) => setPrintName(e.target.value)}
                                type="text"
                                id="printName"
                                placeholder=""
                                className={`inputbox ${validationStates.printName === false ? 'error' : ''}`}
                                onBlur={() => validateInput('printName', /^[\w\W,]+$/)}

                            />
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('contactNum')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Contact Number*</label> <br />
                            <input
                                onChange={(e) => setContactNum(e.target.value)}
                                type="text"
                                id="contactNum"
                                placeholder=""
                                className={`inputbox ${validationStates.contactNum === false ? 'error' : ''}`}
                                onBlur={() => validateInput('contactNum', /^\d+$/)}
                            />
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('position')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Position</label> <br />
                            <input
                                onChange={(e) => setPosition(e.target.value)}
                                type="text"
                                id="position"
                                placeholder=""
                                className={`inputbox`}
                            />
                            {hoveredField === 'position' && (
                                <div className="hover-description">
                                    if applicable.
                                </div>
                            )}
                        </Col>

                        <Col>
                            <label>Date of signature*</label> <br />
                            <input
                                onChange={(e) => setDateSign(e.target.value)}
                                type="date"
                                id="dateSign"
                                value={dateSign}
                                className={`inputbox ${validationStates.dateSign === false ? 'error' : ''}`}
                                onBlur={() => { validateInput('dateSign', /^.*$/); }}
                                min={new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().split('T')[0]} // Disable today and past dates
                            />
                        </Col>

                    </Row>

                </Container>

                <br></br><br></br>

                {/* <Container>

                    <Row>
                        <Col>
                            <div>
                                <input
                                    type="checkbox"
                                    id="checkBox1"
                                    name="checkBox1"
                                    checked={checkBox1}
                                    onChange={(e) => setCheckBox1(e.target.checked)}
                                    className={`checkbox${validationStates.checkBox1 === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('checkBox1', /^.*$/)}
                                />
                                <label htmlFor="checkBox1">
                                    &nbsp;If you wish to request a cancellation, please ensure it is submitted at least 48 hours in advance. The minimum notice period is 24 hours; otherwise, the porting will be processed as scheduled.
                                </label>
                            </div>
                        </Col>
                    </Row>

                    <br />

                    <Row>
                        <Col>
                            <div>
                                <input
                                    type="checkbox"
                                    id="checkBox2"
                                    name="checkBox2"
                                    checked={checkBox2}
                                    onChange={(e) => setCheckBox2(e.target.checked)}
                                    className={`inputbox ${validationStates.checkBox2 === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('checkBox2', /^.*$/)}
                                />
                                <label htmlFor="checkBox2">
                                    &nbsp;Once Porting-in is processed there is no fallback for the ported in numbers.
                                </label>
                            </div>
                        </Col>
                    </Row>

                    <br />

                    <Row>
                        <Col>
                            <div>
                                <input
                                    type="checkbox"
                                    id="checkBox3"
                                    name="checkBox3"
                                    checked={checkBox3}
                                    onChange={(e) => setCheckBox3(e.target.checked)}
                                    className={`inputbox ${validationStates.checkBox3 === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('checkBox3', /^.*$/)}
                                />
                                <label htmlFor="checkBox3">
                                    &nbsp;Please make sure to attach invoice (from the Spanish donor) in the portability request in BTD.
                                </label>
                            </div>
                        </Col>
                    </Row>

                </Container> */}

                <Container>

                    <Row>
                        <Col>
                            <div className="checkbox-container">
                                <input
                                    type="checkbox"
                                    id="checkBox1"
                                    name="checkBox1"
                                    checked={checkBox1}
                                    onChange={(e) => setCheckBox1(e.target.checked)}
                                    className={validationStates.checkBox1 === false ? 'error' : ''}
                                    onBlur={() => validateInput('checkBox1', /^.*$/)}
                                />
                                <label htmlFor="checkBox1">
                                    If you wish to request a cancellation, please ensure it is submitted at least 48 hours in advance.
                                    The minimum notice period is 24 hours; otherwise, the porting will be processed as scheduled.
                                </label>
                            </div>
                        </Col>
                    </Row>

                    <br></br>

                    <Row>
                        <Col>
                            <div className="checkbox-container">
                                <input
                                    type="checkbox"
                                    id="checkBox2"
                                    name="checkBox2"
                                    checked={checkBox2}
                                    onChange={(e) => setCheckBox2(e.target.checked)}
                                    className={validationStates.checkBox2 === false ? 'error' : ''}
                                    onBlur={() => validateInput('checkBox2', /^.*$/)}
                                />
                                <label htmlFor="checkBox2">
                                    Once Porting-in is processed there is no fallback for the ported in numbers.
                                </label>
                            </div>
                        </Col>
                    </Row>

                    <br></br>

                    <Row>
                        <Col>
                            <div className="checkbox-container">
                                <input
                                    type="checkbox"
                                    id="checkBox3"
                                    name="checkBox3"
                                    checked={checkBox3}
                                    onChange={(e) => setCheckBox3(e.target.checked)}
                                    className={validationStates.checkBox3 === false ? 'error' : ''}
                                    onBlur={() => validateInput('checkBox3', /^.*$/)}
                                />
                                <label htmlFor="checkBox3">
                                    Please make sure to attach invoice (from the Spanish donor) in the portability request in BTD otherwise LOA will be rejected.
                                </label>
                            </div>
                        </Col>
                    </Row>

                </Container>


                <br></br><br></br>

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Button variant="primary" type="save" onClick={save}>Save</Button>
                    <Button variant="primary" type="submit" onClick={Submit}>Generate LOA</Button>
                    <Button variant="primary" type="reset" onClick={Reset} style={{ marginRight: '20px' }}>Reset</Button>
                </div>
            </div>

        </div>
    );
}

export default Spain;